// extracted by mini-css-extract-plugin
module.exports = {"head":"services_head__HOz_G","services":"services_services__12Xpq"};